import { Slot as RUISlot } from "@radix-ui/react-slot";
var Slot = RUISlot;
export {
  Slot
};
//# sourceMappingURL=Slot.js.map
